import React from 'react';
import { Link } from 'react-router-dom';

const items = [
  {
    id: 1,
    image: '/assests/landingPic3.png',
    title: 'Trading Events',
    details:
      'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
    date: '23/09/2021',
    time: '12.00 PM',
  },
  {
    id: 2,
    image: '/assests/landingPic3.png',
    title: 'Trading Events',
    details:
      'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
    date: '23/09/2021',
    time: '12.00 PM',
  },
  {
    id: 3,
    image: 'assests/landingPic3.png',
    title: 'Trading Events',
    details:
      'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
    date: '23/09/2021',
    time: '12.00 PM',
  },
];

const EventCard = () => {
  return (
    <div className='mb-2'>
      <div className='row justify-content-center'>
        {items.map((item) => {
          const { id, image, title, details, date, time } = item;
          return (
            <div className='col-md-3 justify-content-center gap-1'>
              <div
                style={{ backgroundColor: '#F4F4F4' }}
                className='card rounded-0'
                key={id}
              >
                <img src={image} alt='Event Picture' />

                <h4 className='card-title px-2 mt-3 '>{title}</h4>
                <p className='card-text  px-2 '>{details}</p>
                <div className='d-flex'>
                  <div className='d-flex flex-column'>
                    <span className='fw-bold px-2 '>Date : {date}</span>

                    <span className='fw-bold px-2 '>Time : {time}</span>
                  </div>
                  <div className='my-auto'>
                    <p className='ps-3 float-md-end textSky'>
                      <Link to='/buystakes'>
                        <strong>Buy Stakes</strong>
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default EventCard;
